/**
 * ブラウザのページライフサイクルに連動した保存フック（自前・GPL非依存・依存ゼロ）。
 *
 * モバイル等ではタブがバックグラウンド化するとメモリ回収でページが破棄され、
 * 再アクティブ化時に完全リロードされる（=メモリ上のゲーム状態が消える）。
 * これを防ぐため「破棄され得る直前」に必ず保存しておく。
 *
 * 購読イベント:
 *   - visibilitychange (hidden): タブが隠れた瞬間。バックグラウンド化の最も確実な信号。
 *   - pagehide: タブを閉じる/別ページ遷移/bfcache 退避の直前。
 *
 * いずれも標準で型付けされたイベントのみを使用する（freeze 等の実験的イベントは
 * 型安全性のため使わない。上記2つでバックグラウンド対策は十分）。
 */

/**
 * バックグラウンド化・離脱の直前に save を呼ぶよう登録する。
 * save 内の例外はここで握り潰す（保存失敗でページ遷移自体を妨げない）。
 */
export const registerPersistHooks = (save: () => void): void => {
  const persist = (): void => {
    try {
      save();
    } catch (err) {
      console.error('lifecycle: セッション保存に失敗:', err);
    }
  };

  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'hidden') persist();
  });
  window.addEventListener('pagehide', persist);
};
